import { useApolloClient } from "@apollo/client";
import { GetEmployerDetailsQuery, GetEmployerDetailsQueryVariables } from "generated/graphql";
import queries from "Shared/queries";

export function useGetEmployerDetailsQuery() {
  const client = useApolloClient();

  async function getEmployerDetails(email: string) {
    const { data }  = await client.query<GetEmployerDetailsQuery, GetEmployerDetailsQueryVariables>({
      query:  queries.GET_EMPLOYER_DETAILS,
      variables: {
        email,
      }
    });
    const employer = data.employer.currentProvider.employers.items[0];

    return employer;
  }

  return {
    getEmployerDetails,
  };
}
